const parts = [
  `<svg width="420" height="420" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <a target="_blank" href="https://app.opendollar.com/vaults/`, `">
    <style>
      .graph-bg-placeholder {
        fill: none;
        stroke: #000;
        stroke-width: 20;
        opacity: 80%;
      }

      .graph-placeholder {
        fill: none;
        stroke-width: 20;
        stroke-linecap: flat;
        animation: progress 1s ease-out forwards;
      }

      .chart-placeholder {
        stroke: `, `;
        opacity: 40%;
      }

      .risk-ratio-placeholder {
        fill: `, `;
      }

      @keyframes progress {
        0% {
          stroke-dasharray: 0 1005;
        }
      }

      @keyframes liquidation {
        0% {
          opacity: 80%;
        }

        50% {
          opacity: 20%;
        }

        100 {
          opacity: 80%;
        }
      }
    </style>
    <g font-family="Inter, Verdana, sans-serif" style="white-space:pre" font-size="12">
      <path fill="#001828" d="M0 0H420V420H0z" />
      <path fill="url(#gradient-placeholder)" d="M0 0H420V420H0z" />
      <path id="od-pattern-tile" opacity=".05" d="M49.7-40a145 145 0 1 0 0 290m0-290V8.2m0-48.4a145 145 0 1 1 0 290m0-241.6a96.7 96.7 0 1 0 0 193.3m0-193.3a96.7 96.7 0 1 1 0 193.3m0 0v48.3m0-96.6a48.3 48.3 0 0 0 0-96.7v96.7Zm0 0a48.3 48.3 0 0 1 0-96.7v96.7Z" stroke="#fff" />
      <use xlink:href="#od-pattern-tile" x="290" />
      <use xlink:href="#od-pattern-tile" y="290" />
      <use xlink:href="#od-pattern-tile" x="290" y="290" />
      <use xlink:href="#od-pattern-tile" x="193" y="145" />
      <text fill="#00587E" xml:space="preserve">
        <tspan x="24" y="40.7">VAULT ID</tspan>
      </text>
      <text fill="#1499DA" xml:space="preserve" font-size="22">
        <tspan x="24" y="65">`, `</tspan>
      </text>
      <text fill="#00587E" xml:space="preserve">
        <tspan x="315.9" y="40.7">STABILITY FEE</tspan>
      </text>
      <text fill="#1499DA" xml:space="preserve" font-size="22">
        <tspan x="443" y="63.3" text-anchor="end">`, `</tspan>
      </text>
      <text opacity=".3" transform="rotate(90 -66.5 101.5)" fill="#fff" xml:space="preserve" font-size="10">
        <tspan x=".5" y="7.3">opendollar.com</tspan>
      </text>
      <text `, `fill="#00587E" xml:space="preserve" font-weight="600">
        <tspan x="102" y="168.9">DEBT</tspan>
      </text>
      <text fill="#D0F1FF" xml:space="preserve" font-size="24">
        <tspan x="102" y="194">`, `</tspan>
      </text>
      <text fill="#00587E" xml:space="preserve" font-weight="600">
        <tspan x="102" y="229.9">COLLATERAL</tspan>
      </text>
      <text fill="#D0F1FF" xml:space="preserve" font-size="24">
        <tspan x="102" y="255">`, `</tspan>
      </text>
      <text opacity=".3" transform="rotate(-90 326.5 -58.5)" fill="#fff" xml:space="preserve" font-size="10">
        <tspan x="-10.3" y="7.3">Updated `, `</tspan>
      </text>
      <g opacity=".6">
        <text fill="#fff" xml:space="preserve">
          <tspan font-size="10" x="24" y="387.4">Powered by</tspan>
        </text>
        <svg x="53" y="375.8" width="127" height="16.2" viewBox="0 0 508 104" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M168.804 74a12.87 12.87 0 0 1-5.27-5.17 15.66 15.66 0 0 1-1.86-7.74V42a15.54 15.54 0 0 1 1.86-7.67 12.9 12.9 0 0 1 5.27-5.18 18.1 18.1 0 0 1 15.82 0 13 13 0 0 1 5.31 5.18 15.3 15.3 0 0 1 1.89 7.67v19.07c.057 2.7-.594 5.37-1.89 7.74a13 13 0 0 1-5.31 5.17 18 18 0 0 1-15.82 0zm13.19-7.07a7.77 7.77 0 0 0 2-5.51v-19.6a7.87 7.87 0 0 0-2-5.58 6.92 6.92 0 0 0-5.31-2.13 6.76 6.76 0 0 0-5.21 2.13 8 8 0 0 0-2 5.58v19.6a7.84 7.84 0 0 0 2 5.51 6.77 6.77 0 0 0 5.21 2.13 6.93 6.93 0 0 0 5.31-2.17zM224.845 58a43 43 0 0 1-.61 7.37q-2.1 10.35-11 10.35c-3.15 0-5.52-1-7.09-3-.09-.14-.18-.2-.27-.17s-.14.1-.14.23v14.4a.8.8 0 0 1-.24.58.77.77 0 0 1-.57.24h-6.22a.8.8 0 0 1-.58-.24.82.82 0 0 1-.23-.58v-45.7a.78.78 0 0 1 .23-.57.78.78 0 0 1 .58-.24h6.22a.76.76 0 0 1 .57.24.75.75 0 0 1 .24.57v1.76a.27.27 0 0 0 .14.27c.09 0 .18 0 .27-.14a8.84 8.84 0 0 1 7.37-3.24 9.22 9.22 0 0 1 6.79 2.57 15.25 15.25 0 0 1 3.75 7.7c.532 2.499.797 5.046.79 7.6m-7.91-.06a26 26 0 0 0-.68-6.76q-1.22-4.4-5-4.4c-2.44 0-4 1.44-4.74 4.33a26.4 26.4 0 0 0-.67 6.83c-.081 2.32.168 4.64.74 6.89.72 2.75 2.26 4.13 4.6 4.13s4-1.33 4.93-4c.614-2.287.89-4.652.82-7.02m39.68-.68-.07 2.91a.72.72 0 0 1-.204.605.73.73 0 0 1-.606.205h-18.12c-.22 0-.33.11-.33.34.09 1.26.18 2.18.27 2.77a5.65 5.65 0 0 0 1.89 3.58 5.76 5.76 0 0 0 3.93 1.33 6.24 6.24 0 0 0 3.41-1 6 6 0 0 0 2.13-2.64.8.8 0 0 1 .388-.479.8.8 0 0 1 .612-.061l5.54 1.15q.81.27.54 1a12 12 0 0 1-4.63 6.45 13.73 13.73 0 0 1-8 2.27q-5.61 0-9-2.71a12.54 12.54 0 0 1-4.4-7.5 29 29 0 0 1-.43-3.85c-.07-1.36-.11-3.16-.11-5.41a31 31 0 0 1 .34-5.34 12 12 0 0 1 4.19-7.88 15.16 15.16 0 0 1 18.43.37 12.63 12.63 0 0 1 4 8.72c.16 1.52.23 3.23.23 5.17m-17.34-9.09a5.75 5.75 0 0 0-1.79 3.55 25 25 0 0 0-.2 3.38.29.29 0 0 0 .33.33h10.76c.23 0 .34-.11.34-.33-.09-1.53-.18-2.64-.27-3.32a5.58 5.58 0 0 0-1.76-3.58 5.8 5.8 0 0 0-7.4 0zm45.93-4.97q2.78 3.099 2.77 8.58v22.59a.82.82 0 0 1-.81.81h-6.22a.78.78 0 0 1-.58-.24.77.77 0 0 1-.23-.57v-21.5a6.57 6.57 0 0 0-1.39-4.4 4.67 4.67 0 0 0-3.75-1.62 4.93 4.93 0 0 0-3.89 1.65 6.5 6.5 0 0 0-1.45 4.43v21.44a.82.82 0 0 1-.81.81h-6.22a.78.78 0 0 1-.58-.24.77.77 0 0 1-.23-.57V41.44a.75.75 0 0 1 .23-.57.78.78 0 0 1 .58-.24h6.22a.78.78 0 0 1 .57.24.75.75 0 0 1 .24.57v1.76a.28.28 0 0 0 .13.27c.09 0 .18 0 .27-.14a9.18 9.18 0 0 1 7.44-3.24 9.78 9.78 0 0 1 7.71 3.11m21.549 31.74a.8.8 0 0 1-.23-.57V28.66a.81.81 0 0 1 .495-.751.8.8 0 0 1 .315-.06h14q6.55.001 10.52 3.65a12.65 12.65 0 0 1 4 9.74v20.55a12.65 12.65 0 0 1-4 9.74q-4 3.642-10.52 3.65h-14a.78.78 0 0 1-.58-.24m7.95-6.52 6.69-.07a5.94 5.94 0 0 0 4.67-2 8.47 8.47 0 0 0 1.89-5.44V42.12a8 8 0 0 0-1.79-5.48 6.06 6.06 0 0 0-4.77-2h-6.69a.3.3 0 0 0-.327.202.3.3 0 0 0-.013.138v33.13a.31.31 0 0 0 .211.3.3.3 0 0 0 .129.01m30.671 4.36a12.3 12.3 0 0 1-4.26-7.95 42.4 42.4 0 0 1-.54-7 43.4 43.4 0 0 1 .54-7.1 11.86 11.86 0 0 1 4.33-7.81 13.94 13.94 0 0 1 9-2.87 13.6 13.6 0 0 1 8.86 2.87 12 12 0 0 1 4.26 7.74c.367 2.35.548 4.723.54 7.1a43.5 43.5 0 0 1-.48 7 12.3 12.3 0 0 1-4.26 8 15.21 15.21 0 0 1-18 0zm12.74-5.31a6.5 6.5 0 0 0 1.86-3.92c.18-2.34.27-4.24.27-5.68s-.09-3.4-.27-5.75a6.18 6.18 0 0 0-1.86-3.85 5.71 5.71 0 0 0-7.54 0 6.3 6.3 0 0 0-1.82 3.85 52 52 0 0 0-.27 5.75 49 49 0 0 0 .27 5.68 6.63 6.63 0 0 0 1.82 3.92 5.51 5.51 0 0 0 7.54 0m15.469 7.47a.8.8 0 0 1-.229-.57V28.66a.81.81 0 0 1 .494-.751.8.8 0 0 1 .316-.06h6.21a.76.76 0 0 1 .569.24.77.77 0 0 1 .241.57v45.71a.77.77 0 0 1-.241.57.75.75 0 0 1-.569.24h-6.22a.78.78 0 0 1-.571-.24m13.951.001a.77.77 0 0 1-.24-.57V28.66a.78.78 0 0 1 .24-.57.75.75 0 0 1 .57-.24h6.27a.78.78 0 0 1 .58.24.8.8 0 0 1 .23.57v45.71a.81.81 0 0 1-.495.75.8.8 0 0 1-.315.06h-6.22a.75.75 0 0 1-.62-.24m33.05-33.4a11.25 11.25 0 0 1 4.63 4 10.6 10.6 0 0 1 1.66 5.89v22.92a.823.823 0 0 1-.81.81h-6.22a.82.82 0 0 1-.82-.81v-1.69a.29.29 0 0 0-.13-.28.23.23 0 0 0-.27.07q-2.84 3.251-8.18 3.25a12 12 0 0 1-7.57-2.4c-2.08-1.6-3.11-4.2-3.11-7.81q0-5.678 3.61-8.45 3.61-2.77 10-2.77h5.34a.3.3 0 0 0 .318-.204.3.3 0 0 0 .012-.135v-1.69a5.52 5.52 0 0 0-1.38-4 5 5 0 0 0-3.82-1.45 5.28 5.28 0 0 0-3.21.91 4 4 0 0 0-1.59 2.47.904.904 0 0 1-1 .74l-6.56-.4a.78.78 0 0 1-.57-.24.51.51 0 0 1-.17-.51 9.6 9.6 0 0 1 4-7 14.56 14.56 0 0 1 9-2.7c2.363-.04 4.704.466 6.84 1.48m-3.52 26.3a4.8 4.8 0 0 0 1.492-1.753 4.8 4.8 0 0 0 .508-2.246V60.3a.3.3 0 0 0-.082-.25.3.3 0 0 0-.248-.09h-4.53a7.67 7.67 0 0 0-4.7 1.29 4.37 4.37 0 0 0-1.73 3.72 4.06 4.06 0 0 0 1.32 3.28 5.13 5.13 0 0 0 3.42 1.11 7.23 7.23 0 0 0 4.55-1.52M451.074 41a.85.85 0 0 1 .41 1l-1.11 6.2c0 .54-.36.7-1 .47a5.8 5.8 0 0 0-2-.33q-.714.017-1.42.13a5.4 5.4 0 0 0-3.82 2.1 7.34 7.34 0 0 0-1.52 4.73v19.07a.805.805 0 0 1-.81.81h-6.22a.75.75 0 0 1-.57-.24.78.78 0 0 1-.24-.57V41.44a.82.82 0 0 1 .81-.81h6.22a.78.78 0 0 1 .58.24.8.8 0 0 1 .23.57v2.91c0 .18 0 .28.1.3s.15 0 .24-.17q2.43-4.26 6.83-4.26a6.57 6.57 0 0 1 3.29.78M66.392 52A29.61 29.61 0 0 0 96 81.608V92a40 40 0 0 1 0-80v10.392A29.61 29.61 0 0 0 66.392 52" fill="#fff"/>
            <path d="M125.608 52A29.607 29.607 0 0 0 96 22.392V12a40 40 0 0 1 40 40 40 40 0 0 1-40 40V81.608A29.606 29.606 0 0 0 125.608 52M96 75a23 23 0 1 1 0-46z" fill="#A4A9B0"/>
            <path d="M96 29a23.003 23.003 0 0 1 23 23 23 23 0 0 1-14.198 21.25A23 23 0 0 1 96 75z" fill="#fff"/>
        </svg>
     </g>
      <g class="chart-placeholder">
        <path class="graph-bg-placeholder" d="M210 40a160 160 0 0 1 0 320 160 160 0 0 1 0-320" />
        <!-- Chart Percentage -->
        <path class="graph-placeholder" stroke-dasharray="calc(1005 * `, `), 1005" d="M210 40a160 160 0 0 1 0 320 160 160 0 0 1 0-320" />
      </g>
      <g class="risk-ratio-placeholder">
        <rect `, `x="242" y="306" width="154" height="82" rx="8" fill="#001828" fill-opacity=".7" />
        <circle cx="243" cy="326.5" r="4" />
        <text xml:space="preserve" font-weight="600">
          <tspan x="255" y="330.7">`, ` RISK`, `</tspan>
        </text>
        <text xml:space="preserve">
          <tspan x="255" y="355.7">COLLATERAL</tspan>
          <tspan x="255" y="371.7">RATIO `, `</tspan>
        </text>
      </g>
    </g>
    <defs>
      <!-- Gradient -->
      <radialGradient id="gradient-placeholder" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(-133.2 301 119) scale(368.295)"><stop stop-color="`, `" /><stop offset="1" stop-color="`, `" stop-opacity="0" /></radialGradient>
    </defs>
  </a>
</svg>`,
];

export { parts };